import graphql from 'babel-plugin-relay/macro';

/**
 * Fragments
 */
export const FEE_INLINE_FRAGMENT = graphql`
  fragment feeInlineFragment on Fee @inline {
    id
    name
    amount
    createdAt
    createdBy
    currencyCode
    description
    externalRef
    type
  }
`;

export const FEES_PAGINATION_FRAGMENT = graphql`
  fragment feesPaginationFragment on Query @refetchable(queryName: "feesRefetchableQuery") {
    fees(first: $first, after: $after, filter: $filter, ordering: $ordering)
      @connection(key: "FeesPaginationFragment_fees")
      @skip(if: $skip) {
      __id
      count
      edges {
        __id
        node {
          ...feeInlineFragment
        }
      }
    }
  }
`;

/**
 * Queries
 */
export const FEES_QUERY = graphql`
  query feesQuery($first: Int!, $after: String, $ordering: [FeeOrdering!], $filter: FeeFilter, $skip: Boolean = false) {
    ...feesPaginationFragment
  }
`;

/**
 * Mutations
 */
export const FEE_DELETE_MUTATION = graphql`
  mutation feeDeleteMutation($connections: [ID!]!, $id: ID!) {
    deleteFee(id: $id) {
      id @deleteEdge(connections: $connections)
    }
  }
`;

export const FEE_CREATE_MUTATION = graphql`
  mutation feeCreateMutation($connections: [ID!]!, $input: FeeCreateInput!) {
    createFee(input: $input) {
      fee @prependNode(connections: $connections, edgeTypeName: "Edge") {
        ...feeInlineFragment
      }
    }
  }
`;

export const FEE_UPDATE_MUTATION = graphql`
  mutation feeUpdateMutation($connections: [ID!]!, $id: ID!, $input: FeeUpdateInput!) {
    updateFee(id: $id, input: $input) {
      fee @prependNode(connections: $connections, edgeTypeName: "Edge") {
        ...feeInlineFragment
      }
    }
  }
`;
